import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { element } from 'ember-element-helper';
import styles from '@hokulea/core/layouts.module.css';
import type { ComponentLike } from '@glint/template';
export interface BoxSignature<E extends Element = HTMLDivElement> {
    Element: E;
    Args: {
        element?: ComponentLike<{
            Element: HTMLElement;
        }>;
    };
    Blocks: {
        default: [];
    };
}
export default class Box<E extends Element = HTMLDivElement> extends Component<BoxSignature<E>> {
    static{
        template(`
    {{#let (if @element @element (element "div")) as |Element|}}
      {{! @glint-expect-error https://github.com/typed-ember/glint/issues/610 }}
      <Element class={{styles.container}} ...attributes>
        {{yield}}
      </Element>
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2hva3VsZWEvaG9rdWxlYS9lbWJlci9wYWNrYWdlL3NyYy9jb21wb25lbnRzL2JveC5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuXG5pbXBvcnQgeyBlbGVtZW50IH0gZnJvbSAnZW1iZXItZWxlbWVudC1oZWxwZXInO1xuXG5pbXBvcnQgc3R5bGVzIGZyb20gJ0Bob2t1bGVhL2NvcmUvbGF5b3V0cy5tb2R1bGUuY3NzJztcblxuaW1wb3J0IHR5cGUgeyBDb21wb25lbnRMaWtlIH0gZnJvbSAnQGdsaW50L3RlbXBsYXRlJztcblxuZXhwb3J0IGludGVyZmFjZSBCb3hTaWduYXR1cmU8RSBleHRlbmRzIEVsZW1lbnQgPSBIVE1MRGl2RWxlbWVudD4ge1xuICBFbGVtZW50OiBFO1xuICBBcmdzOiB7XG4gICAgZWxlbWVudD86IENvbXBvbmVudExpa2U8eyBFbGVtZW50OiBIVE1MRWxlbWVudCB9PjtcbiAgfTtcbiAgQmxvY2tzOiB7XG4gICAgZGVmYXVsdDogW107XG4gIH07XG59XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEJveDxFIGV4dGVuZHMgRWxlbWVudCA9IEhUTUxEaXZFbGVtZW50PiBleHRlbmRzIENvbXBvbmVudDxCb3hTaWduYXR1cmU8RT4-IHtcbiAgPHRlbXBsYXRlPlxuICAgIHt7I2xldCAoaWYgQGVsZW1lbnQgQGVsZW1lbnQgKGVsZW1lbnQgXCJkaXZcIikpIGFzIHxFbGVtZW50fH19XG4gICAgICB7eyEgQGdsaW50LWV4cGVjdC1lcnJvciBodHRwczovL2dpdGh1Yi5jb20vdHlwZWQtZW1iZXIvZ2xpbnQvaXNzdWVzLzYxMCB9fVxuICAgICAgPEVsZW1lbnQgY2xhc3M9e3tzdHlsZXMuY29udGFpbmVyfX0gLi4uYXR0cmlidXRlcz5cbiAgICAgICAge3t5aWVsZH19XG4gICAgICA8L0VsZW1lbnQ-XG4gICAge3svbGV0fX1cbiAgPC90ZW1wbGF0ZT5cbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUUzQyxTQUFTLE9BQU8sUUFBUSx1QkFBdUI7QUFFL0MsT0FBTyxZQUFZLG1DQUFtQztBQUV0RCxjQUFjLGFBQWEsUUFBUSxrQkFBa0I7QUFFckQsaUJBQWlCLGFBQWEsVUFBVSxVQUFVO0lBQ2hELFNBQVM7SUFDVDtRQUNFLFVBQVU7WUFBZ0IsU0FBUzs7O0lBRXJDO1FBQ0U7OztBQUlKLGVBQWUsTUFBTSxJQUFJLFVBQVUsVUFBVSx3QkFBd0IsVUFBVSxhQUFhO0lBQzFGLE1BQUE7UUFBQSxTQUFVLENBQUE7Ozs7Ozs7RUFPVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FQQTtBQVFaIn0